import { render, staticRenderFns } from "./PaginatedProjectList.vue?vue&type=template&id=7351abf0"
import script from "./PaginatedProjectList.vue?vue&type=script&lang=ts"
export * from "./PaginatedProjectList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports